// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import AMap from 'vue-amap';
import AxiosPlugin from "./plugins/AxiosPlugin";
import Vant, {Checkbox, CheckboxGroup} from 'vant';
import VueLazyload from 'vue-lazyload';
import 'vant/lib/index.css';
import 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import queryMixin from './utils/routerPushQuery';
import axios from 'axios';
import lrz from "lrz";
  axios.interceptors.request.use((config) => {
    // 在发送请求之前对config进行处理
    // 检查config.params是否存在，如果不存在则创建一个空对象
    config.params = config.params || {};
    // 检查是否需要跳过拦截器
    if (config.params.isPass) {
      return config;
    }
    const searchParams = new URLSearchParams(window.location.search);
    // 获取URL中的参数值
    const riderId = searchParams.get("riderId") || searchParams.get("riderid");
    const riderName = searchParams.get("riderName");
    const riderMobile = searchParams.get("riderMobile") || searchParams.get("mobile");
    const dltoken = searchParams.get("dltoken");
    const PhoneType = searchParams.get("PhoneType");
    const city = searchParams.get("city");

    // 将参数值添加到config.params中
    config.params.riderId = riderId;
    config.params.riderName = riderName;
    config.params.riderMobile = riderMobile;
    config.params.dltoken = dltoken;
    config.params.PhoneType = PhoneType;
    config.params.city = city;

    return config;
  }, function (error) {
    return Promise.reject(error);
  });
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

Vue.use(AxiosPlugin)
Vue.config.productionTip = false;
Vue.use(Vant);


/**
 * 获取URL参数
 * @param name 参数名
 * @returns {string | null}
 */
Vue.prototype.getUrlParameters = function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

Vue.prototype.$beforeUpload = function (file){
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isLt100k = file.size / 1024 / 1024 < 10;
    if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
    }
    if (!isLt100k) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
    }
    try {
        return new Promise((resolve, reject) => {
            // 使用lrz进行压缩
            lrz(file, { quality: 0.6 }) // 这里设置压缩质量，可以根据需要调整
                .then((result) => {
                    const compressedFile = result.file;
                    resolve(compressedFile);
                })
                .catch((err) => {
                    console.error('压缩图片时出错:', err);
                    // 调用reject来阻止上传
                    reject(false);
                });
        });
    } catch (error) {
        this.$message.error('上图片压缩出错');
        console.error(error);
        return false; // 阻止文件上传
    }
}


AMap.initAMapApiLoader({
    key: 'bb7740e6b8d69cb50823ec3c5709d0f9',
    plugin: [
        'AMap.Autocomplete', //输入提示插件
        'AMap.PlaceSearch', //POI搜索插件
        'AMap.Scale', //右下角缩略图插件 比例尺
        'AMap.OverView', //地图鹰眼插件
        'AMap.ToolBar', //地图工具条
        'AMap.MapType', //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        'AMap.PolyEditor', //编辑 折线多，边形
        'AMap.CircleEditor', //圆形编辑器插件
        'AMap.Geolocation', //定位控件，用来获取和展示用户主机所在的经纬度位置
    ],
    // uiVersion: '1.1', // ui库版本，不配置不加载,
    v: '2.0',
});
Vue.use(AMap);
Vue.use(ElementUI);
Vue.use(VueLazyload);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.mixin(queryMixin)
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js